import React from "react";

import {
  Box,
  Autocomplete,
  Divider,
  ListSubheader,
  Stack,
  TextField,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { HelpText } from "@/components/atoms";
import { GeoFenceLocation } from "@/types";

interface LocationSelectionProps {
  locations: GeoFenceLocation[];
  selection?: GeoFenceLocation[];
  onSelect: (locations: GeoFenceLocation[]) => void;
  disabled?: boolean;
}

const LocationSelection: React.FC<LocationSelectionProps> = ({
  locations,
  selection,
  onSelect,
  disabled = false,
}) => {
  const theme = useTheme();

  const handleLocationSelect = (event: any, locations: GeoFenceLocation[]) => {
    onSelect(locations);
  };

  return (
    <Stack
      spacing={2}
      border={1}
      borderRadius={1}
      borderColor={theme.palette.divider}
      p={2}
      sx={{ minHeight: 130, minWidth: 300, maxWidth: 612 }}
    >
      <HelpText
        text="Location Filter"
        helpText="Select additional locations to filter your audience"
      />
      <Autocomplete
        id="location-select"
        multiple
        limitTags={2}
        disabled={disabled}
        disableCloseOnSelect
        color="secondary"
        options={locations}
        value={selection ?? []}
        onChange={handleLocationSelect}
        groupBy={(option) => option.geo_type}
        getOptionLabel={(option) => option.geo_name}
        renderGroup={(params) => [
          <Box width="100%">
            <Divider
              textAlign="left"
              sx={{
                "&::before, &::after": {
                  borderColor: theme.palette.secondary.main,
                },
              }}
            >
              <ListSubheader
                key={params.key}
                disableSticky
                sx={{
                  textTransform: "uppercase",
                  fontFamily: "cera-pro-bold",
                  color: theme.palette.secondary.main,
                  fontSize: "16px",
                }}
              >
                {params.group}
              </ListSubheader>
            </Divider>
          </Box>,
          params.children,
        ]}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label="Select Locations"
            variant="outlined"
            color="secondary"
            disabled={disabled}
          />
        )}
        // renderTags={() => null}
      />
    </Stack>
  );
};

export default LocationSelection;
